export const checkPromo = (dropOffPostcode?: string, addressId?: string) => {
  if (dropOffPostcode?.split(" ").join("") === "EC1N7UU" && addressId === "medical-laboratory") {
    return true;
  }

  return false;
};
